import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "d-flex flex-center row g-3 align-items-center" }
const _hoisted_3 = { class: "card-header px-5 pb-6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-sm-12 gy-10 px-lg-10" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  class: "fs-1 my-7",
  style: {"word-wrap":"break-word"}
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)
const _hoisted_11 = { class: "card-toolbar" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-arrow-right",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_13 = { class: "card-body px-3 pb-20 pt-4" }
const _hoisted_14 = {
  key: 0,
  class: "sidebar-nav nav nav-tabs text-uppercase fw-bolder",
  id: "business_tabs",
  role: "tablist"
}
const _hoisted_15 = ["href", "id", "onClick"]
const _hoisted_16 = { class: "fs-2 fw-bolder" }
const _hoisted_17 = {
  key: 0,
  class: "fa fa-lightbulb"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", { class: "my-6" }, null, -1)
const _hoisted_19 = {
  id: "kt_sidebar_content",
  class: "pt-5 pb-10 px-5 px-lg-5"
}
const _hoisted_20 = {
  class: "me-lg-n2 pe-lg-2",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "0px",
  "data-kt-scroll-dependencies": "#kt_sidebar_tabs, #kt_sidebar_footer",
  "data-kt-scroll-wrappers": "#kt_sidebar_content",
  style: {"min-height":"800px"}
}
const _hoisted_21 = { class: "tab-content" }
const _hoisted_22 = { class: "row d-flex justify-content-between align-items-center" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  class: "card-header",
  style: {"border-bottom":"0"}
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("hr", { class: "my-3" }, null, -1)
const _hoisted_28 = { class: "card-toolbar my-2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-right",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "col-lg-6 col-sm-12 d-md-flex flex-row-fluid ms-auto bgi-no-repeat bgi-size-cover",
            style: _normalizeStyle([{
              backgroundPosition: 'center',
              backgroundImage: 'url(' + _ctx.page.banner + ')',
            }, {"min-height":"370px","border-top-left-radius":"0.5rem !important","border-top-right-radius":"0.5rem !important"}])
          }, null, 4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", {
              class: "fw-bolder text-dark display-6",
              style: {"font-size":"calc(3rem + 0.7vw) !important","font-weight":"400"},
              innerHTML: _ctx.page.title
            }, null, 8, _hoisted_6),
            _createElementVNode("h3", null, [
              _createElementVNode("small", {
                class: "text-muted fw-bolder",
                innerHTML: _ctx.page.description
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", {
                innerHTML: _ctx.page.shortDescription
              }, null, 8, _hoisted_9)
            ]),
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: "/adicionar-negocio",
                class: "btn btn-lg btn-outline-secondary text-dark"
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _createTextVNode(" Adicionar Ideia de Negócio ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        false
          ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (nav) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: nav.id,
                  class: "nav-item col-6"
                }, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link text-dark fs-4", {
                active: _ctx.currentActive == nav.id,
              }]),
                    style: {"border-radius":"0 !important"},
                    "data-bs-toggle": "tab",
                    href: `#business_tab_pane_${nav.id}`,
                    id: `business_tab_${nav.id}`,
                    onClick: ($event: any) => (_ctx.setActive(nav.id))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas", nav.icon]),
                      "aria-hidden": "true"
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(nav.label), 1)
                  ], 10, _hoisted_15)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("h2", _hoisted_16, [
          false
            ? (_openBlock(), _createElementBlock("i", _hoisted_17))
            : _createCommentVNode("", true),
          _createTextVNode(" Seus Negócios ")
        ]),
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", {
                  active: _ctx.currentActive == 1,
                }]),
                id: "kt_sidebar_tab_pane_1",
                role: "tabpanel"
              }, [
                _createElementVNode("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.business_collection, (i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i.id,
                      class: "card-custom card-stretch col-sm-12 col-lg-6 my-8",
                      style: {"border-radius":"0.5rem","border":"1px solid #ccc"}
                    }, [
                      _createElementVNode("div", _hoisted_23, [
                        (i.metadata.bannerHeader && false)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.$router.push('/@' + i.slugname)),
                              class: "col-12 flex-row-fluid bgi-no-repeat bgi-size-cover bgi-position-y-center bgi-position-x-left mx-3",
                              style: _normalizeStyle([{
                          backgroundImage:
                            'url(' + i.metadata.bannerHeader + ')',
                        }, {"min-height":"220px","border-top-left-radius":"0.5rem","border-top-right-radius":"0.5rem"}])
                            }, null, 12, _hoisted_24))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("h2", {
                          onClick: ($event: any) => (_ctx.$router.push('/@' + i.slugname)),
                          class: "card-title"
                        }, _toDisplayString(i.name), 9, _hoisted_26)
                      ]),
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_router_link, {
                          to: '/@' + i.slugname,
                          class: "btn btn-md btn-outline-secondary text-dark"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_29,
                            _createTextVNode(" Gerenciar ")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]))
                  }), 128))
                ])
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", null, null, 512), [
      [
        _directive_loading,
        _ctx.fullscreenLoading,
        void 0,
        {
          fullscreen: true,
          lock: true
        }
      ]
    ])
  ]))
}